import React from 'react';
import { bool, node, func, number, string, oneOf } from 'prop-types';

const Button = (props) => {
  const disabled = !(props.canSubmit && props.disabled !== true);

  return (
    <button
      tabIndex={props.tabIndex}
      disabled={disabled}
      className={props.className}
      onClick={props.onClick}
      type={props.type}
    >
      {props.text || props.children}
    </button>
  );
};

Button.propTypes = {
  canSubmit: bool,
  tabIndex: number,
  disabled: bool,
  onClick: func,
  className: string,
  type: oneOf(['submit', 'button', 'reset']).isRequired,
  children: node,
  text: string,
};

export default Button;
